import { render, staticRenderFns } from "./AppealChatMessage.vue?vue&type=template&id=0922c0d3&scoped=true&"
import script from "./AppealChatMessage.vue?vue&type=script&lang=ts&"
export * from "./AppealChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AppealChatMessage.vue?vue&type=style&index=0&id=0922c0d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922c0d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
